import { formatDistanceToNowStrict } from 'date-fns'

/**
 * Money is integer cents everywhere in the API. Formatting is display-only —
 * never do money math in the client beyond rendering.
 */
export function formatMoney(cents: number, currency: string, locale?: string): string {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
  }).format(cents / 100)
}

export function formatNumber(value: number, locale?: string): string {
  return new Intl.NumberFormat(locale).format(value)
}

export function formatDate(iso: string | Date, locale?: string): string {
  const date = typeof iso === 'string' ? new Date(iso) : iso
  return new Intl.DateTimeFormat(locale, { dateStyle: 'medium' }).format(date)
}

export function formatDateTime(iso: string | Date, locale?: string): string {
  const date = typeof iso === 'string' ? new Date(iso) : iso
  return new Intl.DateTimeFormat(locale, { dateStyle: 'medium', timeStyle: 'short' }).format(date)
}

/** Relative timestamp ("2 days ago") — pair with an absolute value on hover. */
export function formatRelative(iso: string | Date): string {
  const date = typeof iso === 'string' ? new Date(iso) : iso
  return formatDistanceToNowStrict(date, { addSuffix: true })
}
